import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page not found" />
      <section className="container-x flex flex-col items-center py-40 text-center">
        <span className="font-mono text-6xl font-black text-brand-violet">404</span>
        <h1 className="mt-4 font-heading text-3xl font-bold">Page not found</h1>
        <p className="mt-2 text-zinc-500">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="mt-6 rounded-full bg-brand-violet px-6 py-3 font-bold text-white transition hover:bg-brand-violetHover">Back home</Link>
      </section>
    </>
  );
}
